(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2097,7792],{

/***/ 29564:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/battle-report",
      function () {
        return __webpack_require__(41196);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 670:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ StyledMarkdown; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40286);
/* harmony import */ var theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90408);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ul,\n  ol {\n    padding-left: ",
        " !important;\n\n    li {\n      margin-bottom: ",
        ";\n      margin-top: 0 !important;\n    }\n  }\n\n  ul {\n    li {\n      list-style-type: disc;\n    }\n  }\n\n  ol {\n    li {\n      list-style-type: numeric;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StyledMarkdown = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-da6035b2-0"
})(_templateObject(), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs"));


/***/ }),

/***/ 57792:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MarkdownComponent": function() { return /* binding */ MarkdownComponent; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react_markdown__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84864);
/* harmony import */ var rehype_external_links__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78313);
/* harmony import */ var rehype_raw__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5636);
/* harmony import */ var _MarkdownComponent_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(670);





var ALLOWED_ELEMENTS = [
    "p",
    "strong",
    "ul",
    "ol",
    "li",
    "em",
    "a",
    "br",
    "img",
    "u",
    "blockquote"
];
var MarkdownComponent = function(param) {
    var content = param.content;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_MarkdownComponent_styled__WEBPACK_IMPORTED_MODULE_1__/* .StyledMarkdown */ .F, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_markdown__WEBPACK_IMPORTED_MODULE_2__/* .ReactMarkdown */ .D, {
            allowedElements: ALLOWED_ELEMENTS,
            rehypePlugins: [
                [
                    rehype_external_links__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z,
                    {
                        target: "_blank"
                    }
                ],
                rehype_raw__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z
            ],
            children: content
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (MarkdownComponent);


/***/ }),

/***/ 41196:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ battle_report; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./components/layout/Page.tsx + 13 modules
var Page = __webpack_require__(9092);
// EXTERNAL MODULE: ./components/shared/Typography.js
var Typography = __webpack_require__(99655);
// EXTERNAL MODULE: ./hooks/useI18n/index.ts + 1 modules
var useI18n = __webpack_require__(39105);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./components/shared/Typography.styled.tsx
var Typography_styled = __webpack_require__(90637);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(40286);
// EXTERNAL MODULE: ./theme/index.js + 247 modules
var theme = __webpack_require__(90408);
;// CONCATENATED MODULE: ./components/marketingSite/battleReport/sections/goals/BattleReportGoals.styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: ",
        " auto;\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n\n  ",
        " {\n    text-align: center;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n  gap: ",
        ";\n  margin-top: ",
        ";\n  margin-bottom: ",
        ";\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n    gap: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  text-transform: uppercase;\n  color: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-weight: ",
        ";\n  line-height: 1.25;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  line-height: 1.2;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: ",
        ";\n  margin-bottom: ",
        ";\n  max-width: ",
        ";\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n  }\n\n  > div {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: ",
        ";\n\n    @media (min-width: ",
        ") {\n      width: 50%;\n    }\n  }\n\n  p {\n    margin: 0;\n    font-size: ",
        ";\n    line-height: 1.333;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  gap: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.333;\n  font-weight: ",
        ";\n\n  > div {\n    width: ",
        ";\n    height: ",
        ";\n    border-radius: ",
        ";\n\n    &.sales {\n      background-color: ",
        ";\n    }\n    &.turnover {\n      background-color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow-y: hidden;\n  overflow-x: hidden;\n\n  @media (max-width: ",
        ") {\n    overflow-x: auto;\n  }\n\n  .recharts-surface {\n    max-height: 100%;\n    margin-top: 3px;\n  }\n\n  .recharts-cartesian-axis-line {\n    stroke: ",
        ";\n  }\n\n  .recharts-text {\n    fill: ",
        ";\n    font-size: ",
        ";\n    text-transform: uppercase;\n    font-weight: ",
        ";\n  }\n\n  .recharts-label {\n    text-transform: inherit;\n    fill: ",
        ";\n  }\n\n  .recharts-legend-wrapper {\n    right: -",
        " !important;\n  }\n\n  .recharts-legend-item {\n    margin-bottom: ",
        ";\n    display: flex !important;\n    align-items: center;\n  }\n\n  .recharts-legend-item-text {\n    color: ",
        " !important;\n    font-size: ",
        ";\n    text-align: left;\n  }\n\n  .recharts-default-tooltip {\n    background-color: ",
        " !important;\n    border: 0 !important;\n    border-radius: ",
        ";\n    padding: ",
        " !important;\n    font-size: ",
        ";\n    color: ",
        ";\n    font-weight: ",
        ";\n    position: relative;\n\n    &::before {\n      content: '';\n      width: 0;\n      height: 0;\n      position: absolute;\n    }\n  }\n\n  .recharts-tooltip-wrapper-bottom .recharts-default-tooltip.tooltip-y::before {\n    border-left: 6px solid transparent;\n    border-right: 6px solid transparent;\n    border-bottom: 6px solid ",
        ";\n    top: -5px;\n    left: 50%;\n    right: unset;\n    transform: translateX(-50%);\n  }\n\n  .recharts-tooltip-wrapper-top .recharts-default-tooltip.tooltip-y::before {\n    border-left: 6px solid transparent;\n    border-right: 6px solid transparent;\n    border-top: 6px solid ",
        ";\n    bottom: -5px;\n    left: 50%;\n    right: unset;\n    transform: translateX(-50%);\n  }\n\n  .recharts-tooltip-wrapper-left .recharts-default-tooltip.tooltip-x::before {\n    border-top: 6px solid transparent;\n    border-bottom: 6px solid transparent;\n    border-left: 6px solid ",
        ";\n    right: -5px;\n    left: unset;\n    top: 50%;\n    transform: translateY(-50%);\n  }\n\n  .recharts-tooltip-wrapper-right .recharts-default-tooltip.tooltip-x::before {\n    border-top: 6px solid transparent;\n    border-bottom: 6px solid transparent;\n    border-right: 6px solid ",
        ";\n    left: -5px;\n    top: 50%;\n    transform: translateY(-50%);\n  }\n\n  .recharts-tooltip-item {\n    padding: 0 !important;\n    color: inherit !important;\n  }\n\n  .recharts-tooltip-item-name {\n    font-weight: ",
        ";\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}



var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d0ee84a1-0"
})(_templateObject(), (0,theme/* container */.nC)("xl"), (0,theme/* spacing */.W0)("xl2"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), Typography_styled/* Heading2 */.XJ);
var StyledTotal = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d0ee84a1-1"
})(_templateObject1(), (0,theme/* spacing */.W0)("mdlg"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("xl2"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("lg"));
var StyledTotalTitle = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    componentId: "sc-d0ee84a1-2"
})(_templateObject2(), (0,theme/* fontFamily */.I8)("display"), (0,theme/* fontSize */.JB)("xl5"), (0,theme/* fontWeight */.Ue)("light"), (0,theme/* color */.$_)("text_subtle"));
var StyledTotalData = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d0ee84a1-3"
})(_templateObject3(), (0,theme/* spacing */.W0)("mdlg"));
var StyledTotalDataItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d0ee84a1-4"
})(_templateObject4(), (0,theme/* spacing */.W0)("xs2"));
var StyledTotalDataItemTitle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-d0ee84a1-5"
})(_templateObject5(), (0,theme/* color */.$_)("text_subtle"), (0,theme/* fontWeight */.Ue)("medium"));
var StyledTotalDataItemValue = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-d0ee84a1-6"
})(_templateObject6(), (0,theme/* fontSize */.JB)("lg"), (0,theme/* fontWeight */.Ue)("extraBold"));
var StyledLegend = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d0ee84a1-7"
})(_templateObject7(), (0,theme/* spacing */.W0)("xl2"), (0,theme/* spacing */.W0)("md"), (0,theme/* container */.nC)("md"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("sm"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("xs"), (0,theme/* color */.$_)("text_subtle"));
var StyledLegendTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d0ee84a1-8"
})(_templateObject8(), (0,theme/* spacing */.W0)("sm"), (0,theme/* fontSize */.JB)("xs"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* radius */.q0)("sm"), (0,theme/* color */.$_)("set3_01"), (0,theme/* color */.$_)("set3_07"));
var StyledChart = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d0ee84a1-9"
})(_templateObject9(), (0,theme/* screen */.sp)("mdMax"), (0,theme/* color */.$_)("midnight_200"), (0,theme/* color */.$_)("text_default"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* color */.$_)("text_subtle"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("xs"), (0,theme/* color */.$_)("text_default"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* color */.$_)("midnight_800"), (0,theme/* radius */.q0)("sm"), (0,theme/* spacing */.W0)("sm"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* color */.$_)("text_white"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* color */.$_)("midnight_800"), (0,theme/* color */.$_)("midnight_800"), (0,theme/* color */.$_)("midnight_800"), (0,theme/* color */.$_)("midnight_800"), (0,theme/* fontWeight */.Ue)("extraBold"));

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/component/ResponsiveContainer.js + 1 modules
var ResponsiveContainer = __webpack_require__(61660);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/chart/BarChart.js
var BarChart = __webpack_require__(80739);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/cartesian/XAxis.js
var XAxis = __webpack_require__(25556);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/cartesian/YAxis.js
var YAxis = __webpack_require__(3131);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/component/Tooltip.js + 1 modules
var Tooltip = __webpack_require__(47857);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/cartesian/Bar.js
var Bar = __webpack_require__(24908);
;// CONCATENATED MODULE: ./components/marketingSite/battleReport/sections/goals/GoalsChart.tsx






var GoalsChart = function(param) {
    var sales = param.sales;
    var locale = (0,router.useRouter)().locale;
    var t = (0,useI18n/* useI18n */.Q)("battle-report").t;
    var filterMonth = function(year, month, property) {
        var filteredData = sales.filter(function(obj) {
            if (obj.attributes.year === year && obj.attributes.month === month) {
                return obj;
            }
        });
        return (filteredData === null || filteredData === void 0 ? void 0 : filteredData.length) ? filteredData[0].attributes[property] : null;
    };
    var getMonthName = function(monthNumber) {
        if (!monthNumber) {
            return "";
        }
        var date = new Date();
        date.setMonth(monthNumber - 1);
        return date.toLocaleString(locale, {
            month: "short"
        });
    };
    var chartData = function() {
        var a = [];
        for(var i = 0; i < 12; i++){
            a.push({
                month: getMonthName(i + 1),
                sales: filterMonth(2023, i + 1, "sales"),
                turnover: filterMonth(2023, i + 1, "billing")
            });
        }
        return a;
    };
    var ref = (0,react.useState)(true), chartDesktop = ref[0], setChartDesktop = ref[1];
    (0,react.useEffect)(function() {
        var isChartDesktop = function isChartDesktop() {
            setChartDesktop(window.matchMedia("(min-width: 1056px)").matches);
        };
        isChartDesktop();
        window.addEventListener("resize", isChartDesktop);
        return function() {
            window.removeEventListener("resize", isChartDesktop);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledChart, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                width: "99%",
                height: chartDesktop ? 250 : 500,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                    data: chartData(),
                    layout: chartDesktop ? "horizontal" : "vertical",
                    children: [
                        chartDesktop && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                                    type: "category",
                                    dataKey: "month",
                                    tickLine: false,
                                    interval: 0,
                                    axisLine: true
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                                    tickLine: false,
                                    width: 60,
                                    axisLine: true,
                                    tickMargin: 5,
                                    tickFormatter: function(tick) {
                                        return "€".concat((Math.sign(tick) * (Math.abs(tick) / 1000)).toFixed(0), "K");
                                    }
                                })
                            ]
                        }),
                        !chartDesktop && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                                    type: "number",
                                    tickLine: false,
                                    axisLine: true,
                                    tickMargin: 5,
                                    tickFormatter: function(tick) {
                                        return "€".concat((Math.sign(tick) * (Math.abs(tick) / 1000)).toFixed(0), "K");
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                                    type: "category",
                                    dataKey: "month",
                                    tickLine: false,
                                    interval: 0,
                                    axisLine: true
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                            cursor: {
                                fill: "transparent"
                            },
                            labelStyle: {
                                display: "none"
                            },
                            separator: ": ",
                            formatter: function(value) {
                                return "".concat(value.toLocaleString(locale), " €");
                            },
                            wrapperClassName: "tooltip-x"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                            dataKey: "sales",
                            barSize: 8,
                            radius: chartDesktop ? [
                                5,
                                5,
                                0,
                                0
                            ] : [
                                0,
                                5,
                                5,
                                0
                            ],
                            fill: "#8DD3C7",
                            name: t("battle-report.objectives.sales")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                            dataKey: "turnover",
                            barSize: 8,
                            radius: chartDesktop ? [
                                5,
                                5,
                                0,
                                0
                            ] : [
                                0,
                                5,
                                5,
                                0
                            ],
                            fill: "#A6D855",
                            name: t("battle-report.objectives.turnover")
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var goals_GoalsChart = (GoalsChart);

;// CONCATENATED MODULE: ./components/marketingSite/battleReport/sections/goals/BattleReportGoals.tsx






var BattleReportGoals = function(param) {
    var sales = param.sales;
    var t = (0,useI18n/* useI18n */.Q)("battle-report").t;
    var locale = (0,router.useRouter)().locale;
    var totalSales = function(year, properties) {
        var totalAmount = 0;
        sales.forEach(function(obj) {
            if (obj.attributes.year === year) {
                properties.forEach(function(property) {
                    totalAmount = totalAmount + obj.attributes[property];
                });
            }
        });
        return totalAmount.toLocaleString(locale);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading2 */.XJ, {
                editorial: true,
                children: t("battle-report.objectives.title")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTotal, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTotalTitle, {
                        children: t("battle-report.objectives.total")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTotalData, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTotalDataItem, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTotalDataItemTitle, {
                                    children: t("battle-report.objectives.sales")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTotalDataItemValue, {
                                    children: [
                                        totalSales(2023, [
                                            "sales",
                                            "billing"
                                        ]),
                                        "€"
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLegend, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLegendTitle, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "sales"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: t("battle-report.objectives.legend.sales.title")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: t("battle-report.objectives.legend.sales.desc")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLegendTitle, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "turnover"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: t("battle-report.objectives.legend.turnover.title")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: t("battle-report.objectives.legend.turnover.desc")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(goals_GoalsChart, {
                sales: sales
            })
        ]
    });
};
/* harmony default export */ var goals_BattleReportGoals = (BattleReportGoals);

// EXTERNAL MODULE: ./components/shared/HtmlTrans.tsx
var HtmlTrans = __webpack_require__(97210);
// EXTERNAL MODULE: ./utils/paths.tsx
var paths = __webpack_require__(64516);
;// CONCATENATED MODULE: ./components/marketingSite/battleReport/sections/hero/BattleReportHero.styled.ts

function BattleReportHero_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-image: ",
        ";\n  background-repeat: no-repeat;\n  background-position: left bottom;\n  background-size: cover;\n  padding: ",
        " ",
        " 0;\n  margin-bottom: ",
        ";\n\n  @media (min-width: ",
        ") {\n    background-image: ",
        ";\n    background-position: left 15% bottom;\n    padding: ",
        " ",
        " 0;\n    background-position: center bottom;\n    margin-bottom: ",
        ";\n    background-size: cover;\n  }\n"
    ]);
    BattleReportHero_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function BattleReportHero_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n"
    ]);
    BattleReportHero_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function BattleReportHero_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  line-height: 1.5;\n  text-align: center;\n\n  @media (min-width: ",
        ") {\n    display: flex;\n    gap: ",
        ";\n    text-align: left;\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n    line-height: 1.6;\n    gap: ",
        ";\n    padding-bottom: ",
        ";\n  }\n\n  img {\n    max-width: 20rem;\n    margin-bottom: -",
        ";\n\n    @media (min-width: ",
        ") {\n      width: 50%;\n      margin-bottom: 0;\n    }\n  }\n\n  > div {\n    @media (min-width: ",
        ") {\n      max-width: 32rem;\n    }\n  }\n"
    ]);
    BattleReportHero_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var StyledHero = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8bd1ef4b-0"
})(BattleReportHero_styled_templateObject(), function() {
    return "url('".concat((0,paths/* getPublicPath */.A)("/images/battleReport/bg-hero.svg"), "')");
}, (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xl5"), (0,theme/* screen */.sp)("md"), function() {
    return "url('".concat((0,paths/* getPublicPath */.A)("/images/battleReport/bg-hero.svg"), "')");
}, (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl4"));
var BattleReportHero_styled_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8bd1ef4b-1"
})(BattleReportHero_styled_templateObject1(), (0,theme/* container */.nC)("xl"));
var StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8bd1ef4b-2"
})(BattleReportHero_styled_templateObject2(), (0,theme/* color */.$_)("text_white"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* spacing */.W0)("xl6"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* screen */.sp)("md"), (0,theme/* screen */.sp)("md"));

;// CONCATENATED MODULE: ./components/marketingSite/battleReport/sections/hero/BattleReportHero.tsx






var BattleReportHero = function() {
    var t = (0,useI18n/* useI18n */.Q)("battle-report").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHero, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BattleReportHero_styled_StyledWrapper, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading1 */.nL, {
                                children: t("battle-report.hero.title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                    ns: "battle-report",
                                    i18nKey: "battle-report.hero.desc"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: (0,paths/* getPublicPath */.A)("/images/battleReport/satellite.svg"),
                        alt: ""
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var hero_BattleReportHero = (BattleReportHero);

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-light-svg-icons/index.mjs
var pro_light_svg_icons = __webpack_require__(38914);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-solid-svg-icons/index.mjs
var pro_solid_svg_icons = __webpack_require__(54933);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(49929);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/shared/MarkdownComponent.tsx
var MarkdownComponent = __webpack_require__(57792);
;// CONCATENATED MODULE: ./components/marketingSite/battleReport/sections/quarter/BattleReportQuarter.styled.ts

function BattleReportQuarter_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  width: 100%;\n  margin: ",
        " auto ",
        ";\n  background-color: ",
        ";\n  padding: 0 ",
        " ",
        ";\n  border-radius: ",
        ";\n  display: flex;\n  flex-direction: column;\n"
    ]);
    BattleReportQuarter_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function BattleReportQuarter_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-flex;\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  text-transform: uppercase;\n  letter-spacing: 0.35em;\n  padding: ",
        ";\n  color: ",
        ";\n  background-color: ",
        ";\n  margin: 0 auto;\n"
    ]);
    BattleReportQuarter_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function BattleReportQuarter_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: ",
        ";\n  margin-bottom: ",
        ";\n  margin-top: ",
        ";\n"
    ]);
    BattleReportQuarter_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function BattleReportQuarter_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        " ",
        ";\n  background: unset;\n  border: 0;\n  border-bottom: ",
        " solid transparent;\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  text-transform: uppercase;\n  line-height: 1;\n  flex-grow: 1;\n  display: flex;\n  justify-content: center;\n  padding: ",
        ";\n  color: ",
        ";\n  transition: 0.2s;\n  cursor: pointer;\n\n  &.is-active {\n    color: ",
        ";\n    border-color: ",
        ";\n  }\n\n  &[disabled] {\n    color: ",
        ";\n    pointer-events: none;\n  }\n"
    ]);
    BattleReportQuarter_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function BattleReportQuarter_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 0;\n  margin-bottom: ",
        ";\n  padding-top: ",
        ";\n  padding-bottom: ",
        ";\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.2;\n  font-weight: ",
        ";\n  border-bottom: 1px solid ",
        ";\n\n  svg {\n    width: ",
        " !important;\n    height: ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    BattleReportQuarter_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function BattleReportQuarter_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  margin-bottom: ",
        ";\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n    gap: ",
        ";\n  }\n\n  > *:first-child {\n    flex-shrink: 0;\n  }\n"
    ]);
    BattleReportQuarter_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function BattleReportQuarter_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  flex-grow: 1;\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n    gap: ",
        ";\n  }\n"
    ]);
    BattleReportQuarter_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function BattleReportQuarter_styled_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-basis: 33.33%;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  gap: ",
        " ",
        ";\n\n  @media (min-width: ",
        ") {\n    flex-direction: column;\n    flex-wrap: unset;\n    gap: ",
        ";\n  }\n"
    ]);
    BattleReportQuarter_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function BattleReportQuarter_styled_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  text-transform: uppercase;\n  font-size: ",
        ";\n  line-height: 1.142;\n  font-weight: ",
        ";\n  letter-spacing: 0.25em;\n  width: 100%;\n\n  @media (min-width: ",
        ") {\n    width: auto;\n  }\n"
    ]);
    BattleReportQuarter_styled_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function BattleReportQuarter_styled_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n"
    ]);
    BattleReportQuarter_styled_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-weight: ",
        ";\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: ",
        ";\n  align-items: center;\n  font-size: ",
        ";\n  font-weight: ",
        ";\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: ",
        ";\n  align-items: center;\n  font-size: ",
        ";\n  font-weight: ",
        ";\n\n  svg {\n    width: ",
        " !important;\n    height: ",
        ";\n  }\n  &.positive svg {\n    color: ",
        ";\n  }\n  &.negative svg {\n    color: ",
        ";\n  }\n  &.neutral svg {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        ";\n  margin-bottom: ",
        ";\n  color: ",
        ";\n  font-weight: ",
        ";\n  text-transform: uppercase;\n  padding: ",
        ";\n  background-color: ",
        ";\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n\n  h6 {\n    margin: 0;\n    font-size: ",
        ";\n    font-weight: ",
        ";\n    display: flex;\n    align-items: flex-start;\n    gap: ",
        ";\n  }\n\n  p {\n    line-height: 1.5;\n    margin-top: 0;\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        ";\n  height: ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 2px solid;\n  border-radius: ",
        ";\n  flex-shrink: 0;\n  margin-top: -2px;\n\n  svg {\n    width: ",
        " !important;\n    height: ",
        ";\n  }\n\n  &.positive {\n    border-color: ",
        ";\n    svg {\n      color: ",
        ";\n    }\n  }\n  &.negative {\n    border-color: ",
        ";\n    svg {\n      color: ",
        ";\n    }\n  }\n  &.neutral {\n    border-color: ",
        ";\n    svg {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}


var BattleReportQuarter_styled_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-579b634f-0"
})(BattleReportQuarter_styled_templateObject(), (0,theme/* container */.nC)("lg"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl5"), (0,theme/* color */.$_)("white"), (0,theme/* spacing */.W0)("xl2"), (0,theme/* spacing */.W0)("xl2"), (0,theme/* radius */.q0)("md"));
var StyledTitle = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    componentId: "sc-579b634f-1"
})(BattleReportQuarter_styled_templateObject1(), (0,theme/* fontSize */.JB)("md"), (0,theme/* fontWeight */.Ue)("extraBold"), (0,theme/* spacing */.W0)("md"), (0,theme/* color */.$_)("text_subtle"), (0,theme/* color */.$_)("midnight_100"));
var StyledTabs = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-579b634f-2"
})(BattleReportQuarter_styled_templateObject2(), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("lg"));
var StyledTab = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-579b634f-3"
})(BattleReportQuarter_styled_templateObject3(), (0,theme/* spacing */.W0)("sm"), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("xs2"), (0,theme/* fontFamily */.I8)("display"), (0,theme/* fontWeight */.Ue)("semiBold"), (0,theme/* fontSize */.JB)("xl2"), (0,theme/* spacing */.W0)("sm"), (0,theme/* color */.$_)("link"), (0,theme/* color */.$_)("text_default"), (0,theme/* color */.$_)("active"), (0,theme/* color */.$_)("text_disabled"));
var StyledSectionTitle = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    componentId: "sc-579b634f-4"
})(BattleReportQuarter_styled_templateObject4(), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* fontWeight */.Ue)("extraBold"), (0,theme/* color */.$_)("emerald_300"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl"), (0,theme/* color */.$_)("emerald_300"));
var StyledData = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-579b634f-5"
})(BattleReportQuarter_styled_templateObject5(), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xl3"));
var StyledDataMonthList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-579b634f-6"
})(BattleReportQuarter_styled_templateObject6(), (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xl"));
var StyledDataMonth = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-579b634f-7"
})(BattleReportQuarter_styled_templateObject7(), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("mdlg"));
var StyledDataMonthTitle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-579b634f-8"
})(BattleReportQuarter_styled_templateObject8(), (0,theme/* color */.$_)("text_subtle"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* fontWeight */.Ue)("extraBold"), (0,theme/* screen */.sp)("md"));
var StyledTendency = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-579b634f-9"
})(BattleReportQuarter_styled_templateObject9(), (0,theme/* spacing */.W0)("xs2"));
var StyledTendencyTitle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-579b634f-10"
})(_templateObject10(), (0,theme/* color */.$_)("text_subtle"), (0,theme/* fontWeight */.Ue)("medium"));
var StyledTendencyValue = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-579b634f-11"
})(_templateObject11(), (0,theme/* spacing */.W0)("xs"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* fontWeight */.Ue)("black"));
var StyledTendencyVariation = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-579b634f-12"
})(_templateObject12(), (0,theme/* spacing */.W0)("xs2"), (0,theme/* fontSize */.JB)("xs"), (0,theme/* fontWeight */.Ue)("extraBold"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* color */.$_)("positive_500"), (0,theme/* color */.$_)("negative_500"), (0,theme/* color */.$_)("notice_500"));
var StyledGoalsTitle = styled_components_browser_esm/* default.h5.withConfig */.ZP.h5.withConfig({
    componentId: "sc-579b634f-13"
})(_templateObject13(), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* color */.$_)("text_subtle"), (0,theme/* fontWeight */.Ue)("extraBold"), (0,theme/* spacing */.W0)("sm"), (0,theme/* color */.$_)("midnight_100"));
var StyledGoal = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-579b634f-14"
})(_templateObject14(), (0,theme/* spacing */.W0)("xs"), (0,theme/* fontSize */.JB)("md"), (0,theme/* fontWeight */.Ue)("extraBold"), (0,theme/* spacing */.W0)("xs"));
var StyledGoalIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-579b634f-15"
})(_templateObject15(), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("lg"), (0,theme/* radius */.q0)("full"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* color */.$_)("positive_500"), (0,theme/* color */.$_)("positive_500"), (0,theme/* color */.$_)("negative_500"), (0,theme/* color */.$_)("negative_500"), (0,theme/* color */.$_)("notice_500"), (0,theme/* color */.$_)("notice_500"));

;// CONCATENATED MODULE: ./components/marketingSite/battleReport/sections/quarter/QuarterChart.tsx





var QuarterChart = function(param) {
    var sales = param.sales;
    var locale = (0,router.useRouter)().locale;
    var t = (0,useI18n/* useI18n */.Q)("battle-report").t;
    var filterMonth = function(month, property) {
        var filteredData = sales === null || sales === void 0 ? void 0 : sales.filter(function(obj) {
            if (obj.attributes.month === month) {
                return obj;
            }
        });
        return filteredData.length ? filteredData[0].attributes[property] : null;
    };
    var getMonthAttributes = function(month) {
        var ref;
        return (ref = sales[month]) === null || ref === void 0 ? void 0 : ref.attributes.month;
    };
    var getMonthName = function(monthNumber) {
        if (!monthNumber) {
            return "";
        }
        var date = new Date();
        date.setMonth(monthNumber - 1);
        return date.toLocaleString(locale, {
            month: "short"
        });
    };
    var chartData = function() {
        var a = [];
        for(var i = 0; i < 3; i++){
            a.push({
                month: getMonthName(getMonthAttributes(i)),
                sales: filterMonth(getMonthAttributes(i), "sales"),
                turnover: filterMonth(getMonthAttributes(i), "billing")
            });
        }
        return a;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledChart, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
            data: chartData(),
            width: 250,
            height: 180,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                    type: "category",
                    dataKey: "month",
                    tickLine: false,
                    interval: 0,
                    axisLine: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                    tickLine: false,
                    width: 60,
                    axisLine: true,
                    tickMargin: 5,
                    tickFormatter: function(tick) {
                        return "€".concat((Math.sign(tick) * (Math.abs(tick) / 1000)).toFixed(0), "K");
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                    cursor: {
                        fill: "transparent"
                    },
                    labelStyle: {
                        display: "none"
                    },
                    separator: ": ",
                    formatter: function(value) {
                        return "".concat(value.toLocaleString(locale), " €");
                    },
                    wrapperClassName: "tooltip-x"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                    dataKey: "sales",
                    barSize: 8,
                    radius: [
                        5,
                        5,
                        0,
                        0
                    ],
                    fill: "#8DD3C7",
                    name: t("battle-report.objectives.sales")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                    dataKey: "turnover",
                    barSize: 8,
                    radius: [
                        5,
                        5,
                        0,
                        0
                    ],
                    fill: "#A6D855",
                    name: t("battle-report.objectives.turnover")
                })
            ]
        })
    });
};
/* harmony default export */ var quarter_QuarterChart = (QuarterChart);

;// CONCATENATED MODULE: ./components/marketingSite/battleReport/sections/quarter/BattleReportQuarter.tsx












var BattleReportQuarter = function(param) {
    var sales = param.sales, goals = param.goals;
    var setTab = function setTab(tabNumber) {
        setActiveQuarter(tabNumber);
    };
    var t = (0,useI18n/* useI18n */.Q)("battle-report").t;
    var locale = (0,router.useRouter)().locale;
    var ref = (0,react.useState)(1), activeQuarter = ref[0], setActiveQuarter = ref[1];
    var filteredYear = function(year) {
        return sales.filter(function(obj) {
            if (obj.attributes.year === year) {
                return obj;
            }
        }).sort(function(a, b) {
            return a.attributes.month - b.attributes.month;
        });
    };
    var currentYear = filteredYear(2023);
    var quarters = Math.floor(currentYear.length / 12 * 4);
    var emptyQuarters = 4 - quarters;
    var filteredQuarter = currentYear.filter(function(el) {
        return el.attributes.month <= activeQuarter * 3 && el.attributes.month >= activeQuarter * 3 - 2;
    });
    var getMonthName = function(monthNumber) {
        var date = new Date();
        date.setMonth(monthNumber - 1);
        return date.toLocaleString(locale, {
            month: "long"
        });
    };
    var monthVariation = function(currentMonth, property) {
        var previousTarget = currentYear[currentMonth - 2].attributes[property];
        var currentTarget = currentYear[currentMonth - 1].attributes[property];
        return parseInt((currentTarget / previousTarget * 100).toFixed(1), 10) - 100;
    };
    var filteredGoals = goals.filter(function(el) {
        if (el.attributes.quarter === "q" + activeQuarter) {
            return el;
        }
    });
    var getDepartments = (0,_to_consumable_array/* default */.Z)(new Set(filteredGoals.map(function(item) {
        return item.attributes.department;
    })));
    var sortedDepartments = (0,_to_consumable_array/* default */.Z)(getDepartments).sort();
    var sortedGoals = filteredGoals.sort(function(a, b) {
        return a.attributes.order - b.attributes.order;
    });
    var sortedGoalsByDepartment = sortedDepartments.map(function(obj) {
        var filteredItems = sortedGoals.filter(function(item) {
            if (item.attributes.department === obj) {
                return item;
            }
        });
        return filteredItems;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BattleReportQuarter_styled_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTitle, {
                children: t("battle-report.report.title")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTabs, {
                children: [
                    (0,_to_consumable_array/* default */.Z)(Array(quarters)).map(function(e, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTab, {
                            type: "button",
                            role: "tab",
                            "aria-selected": activeQuarter === index + 1,
                            "aria-label": "Quarter ".concat(activeQuarter),
                            "aria-controls": "quarter".concat(activeQuarter, "-tabpanel"),
                            id: "quarter".concat(activeQuarter, "-tab"),
                            className: "".concat(activeQuarter === index + 1 ? "is-active" : ""),
                            onClick: function() {
                                setTab(index + 1);
                            },
                            children: [
                                "Q",
                                index + 1
                            ]
                        }, index);
                    }),
                    (0,_to_consumable_array/* default */.Z)(Array(emptyQuarters)).map(function(e, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTab, {
                            disabled: true,
                            type: "button",
                            children: [
                                "Q",
                                quarters ? index + quarters + 1 : undefined
                            ]
                        }, index);
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                id: "quarter".concat(activeQuarter, "-tabpanel"),
                role: "tabpanel",
                "aria-labelledby": "quarter".concat(activeQuarter, "-tab"),
                tabIndex: 0,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSectionTitle, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                icon: pro_light_svg_icons/* faCashRegister */.J4t
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: t("battle-report.report.numbers-title")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledData, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(quarter_QuarterChart, {
                                sales: filteredQuarter
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDataMonthList, {
                                children: filteredQuarter.map(function(e, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDataMonth, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDataMonthTitle, {
                                                children: getMonthName(e.attributes.month)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTendency, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTendencyTitle, {
                                                        children: t("battle-report.report.sales")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTendencyValue, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                children: [
                                                                    e.attributes.sales.toLocaleString(locale),
                                                                    "€"
                                                                ]
                                                            }),
                                                            e.attributes.month !== 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTendencyVariation, {
                                                                className: classnames_default()({
                                                                    positive: monthVariation(e.attributes.month, "sales") > 0,
                                                                    negative: monthVariation(e.attributes.month, "sales") < 0,
                                                                    neutral: monthVariation(e.attributes.month, "sales") === 0
                                                                }),
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                                        icon: monthVariation(e.attributes.month, "sales") > 0 ? pro_solid_svg_icons/* faArrowCircleUp */.M3_ : monthVariation(e.attributes.month, "sales") < 0 ? pro_solid_svg_icons/* faArrowCircleDown */.DY : pro_solid_svg_icons/* faEquals */.Lvu
                                                                    }),
                                                                    monthVariation(e.attributes.month, "sales") !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                        children: [
                                                                            monthVariation(e.attributes.month, "sales"),
                                                                            "%"
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTendency, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTendencyTitle, {
                                                        children: t("battle-report.report.turnover")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTendencyValue, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                children: [
                                                                    e.attributes.billing.toLocaleString(locale),
                                                                    "€"
                                                                ]
                                                            }),
                                                            e.attributes.month !== 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTendencyVariation, {
                                                                className: classnames_default()({
                                                                    positive: monthVariation(e.attributes.month, "billing") > 0,
                                                                    negative: monthVariation(e.attributes.month, "billing") < 0,
                                                                    neutral: monthVariation(e.attributes.month, "billing") === 0
                                                                }),
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                                        icon: monthVariation(e.attributes.month, "billing") > 0 ? pro_solid_svg_icons/* faArrowCircleUp */.M3_ : monthVariation(e.attributes.month, "billing") < 0 ? pro_solid_svg_icons/* faArrowCircleDown */.DY : pro_solid_svg_icons/* faEquals */.Lvu
                                                                    }),
                                                                    monthVariation(e.attributes.month, "billing") !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                        children: [
                                                                            monthVariation(e.attributes.month, "billing"),
                                                                            "%"
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }, index);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSectionTitle, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                icon: pro_light_svg_icons/* faBullseyeArrow */.tq6
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: t("battle-report.report.objectives-title")
                            })
                        ]
                    }),
                    sortedGoalsByDepartment.map(function(goalGroup, index) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledGoalsTitle, {
                                    children: goalGroup[0].attributes.department
                                }),
                                goalGroup === null || goalGroup === void 0 ? void 0 : goalGroup.map(function(goal, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledGoal, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h6", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledGoalIcon, {
                                                        className: "positive",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                            icon: pro_solid_svg_icons/* faArrowCircleUp */.M3_
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: goal.attributes.goalTitle
                                                    })
                                                ]
                                            }),
                                            goal.attributes.goalDescription && /*#__PURE__*/ (0,jsx_runtime.jsx)(MarkdownComponent["default"], {
                                                content: goal.attributes.goalDescription
                                            })
                                        ]
                                    }, index);
                                })
                            ]
                        }, index);
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var quarter_BattleReportQuarter = (BattleReportQuarter);

;// CONCATENATED MODULE: ./components/marketingSite/battleReport/BattleReportComponent.tsx





var BattleReportComponent = function(param) {
    var sales = param.sales, goals = param.goals;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Page/* default */.ZP, {
        hasScrollTop: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(hero_BattleReportHero, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(goals_BattleReportGoals, {
                sales: sales
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(quarter_BattleReportQuarter, {
                sales: sales,
                goals: goals
            })
        ]
    });
};
/* harmony default export */ var battleReport_BattleReportComponent = (BattleReportComponent);

// EXTERNAL MODULE: ./components/shared/HeadMetadata.tsx
var HeadMetadata = __webpack_require__(73412);
// EXTERNAL MODULE: ./hooks/usePageTrack/index.ts + 1 modules
var usePageTrack = __webpack_require__(56002);
// EXTERNAL MODULE: ../../node_modules/next/dist/client/router.js
var client_router = __webpack_require__(93642);
// EXTERNAL MODULE: ./utils/app-urls.ts
var app_urls = __webpack_require__(62177);
;// CONCATENATED MODULE: ./pages/battle-report.tsx
/* eslint-disable @typescript-eslint/no-explicit-any */ 








var parseJSON = function(resp) {
    return resp.json ? resp.json() : resp;
};
var checkStatus = function(resp) {
    if (resp.status >= 200 && resp.status < 300) {
        return resp;
    }
    return parseJSON(resp).then(function(resp) {
        throw resp;
    });
};
var headers = {
    "Content-Type": "application/json"
};
var BattleReportPage = function(param) {
    var baseUrl = param.baseUrl;
    var t = (0,useI18n/* useI18n */.Q)("battle-report").t;
    (0,usePageTrack/* usePageTrack */.N)("Landing - Page Loaded");
    var locale = (0,client_router.useRouter)().locale;
    var ref = (0,react.useState)([]), warReportsSales = ref[0], setWarReportsSales = ref[1];
    var ref1 = (0,react.useState)([]), warReportsGoals = ref1[0], setWarReportsGoals = ref1[1];
    (0,react.useEffect)(function() {
        fetch("https://cms.getmanfred.com/api/war-reports-sales", {
            headers: headers,
            method: "GET"
        }).then(checkStatus).then(parseJSON).then(function(param) {
            var data = param.data;
            return setWarReportsSales(data);
        });
    }, []);
    (0,react.useEffect)(function() {
        fetch("https://cms.getmanfred.com/api/war-report-goals?populate=%2A&pagination[pageSize]=100&locale=".concat(locale), {
            headers: headers,
            method: "GET"
        }).then(checkStatus).then(parseJSON).then(function(param) {
            var data = param.data;
            return setWarReportsGoals(data);
        });
    }, [
        locale
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadMetadata/* default */.Z, {
                title: t("battle-report.page_title"),
                url: app_urls/* APP_URLS.battleReport */.uu.battleReport,
                desc: t("battle-report.page_description"),
                imgUrl: "".concat(baseUrl).concat((0,paths/* getPublicPath */.A)("/images/cards/card_battle_report.png"))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(battleReport_BattleReportComponent, {
                sales: warReportsSales,
                goals: warReportsGoals
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var battle_report = (BattleReportPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7482,6129,8746,9001,2077,4926,9161,9092,289,9774,2888,179], function() { return __webpack_exec__(29564); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);